import styled from 'styled-components';

import media from 'apps/auth/theme/media';

interface ContainerProps {
    isSelected?: boolean;
    isHiddenMobile?: boolean;
}

export const Container = styled.li<ContainerProps>`
    width: 25%;
    color: ${(props) => (props.isSelected ? props.theme.black : props.theme.grey_72_lc)};
    display: ${(props) => (props.isHiddenMobile ? 'none' : 'block')};

    ${media.desktop1224} {
        width: auto;
        display: block;
    }
`;

export const MenuLink = styled.a`
    font-family: var(--font-tag), sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    font-size: 8px;
    letter-spacing: 0.09em;
    line-height: 10px;
    padding-bottom: 4px;
    padding-top: 6px;
    text-transform: uppercase;

    ${media.tablet720} {
        font-size: 11px;
        letter-spacing: 0.08em;
        line-height: 16px;
        padding-bottom: 8px;
        padding-top: 10px;
    }

    ${media.desktop1224} {
        font-family: var(--font-main), sans-serif;
        flex-direction: row;
        font-size: 17px;
        line-height: 24px;
        letter-spacing: normal;
        padding: 28px 32px;
        text-transform: none;

        &:hover {
            background: ${(props) => props.theme.grey_8_lc};
        }
    }

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
        padding: 32px;
    }
`;

export const IconWrapper = styled.span`
    height: 24px;
    position: relative;
    margin-bottom: 4px;

    ${media.tablet720} {
        margin-bottom: 6px;
    }

    ${media.desktop1224} {
        margin-bottom: 0;
        margin-right: 24px;
    }
`;

export const Notification = styled.span`
    border-radius: 12px;
    display: inline-block;
    font-size: 8px;
    height: 12px;
    line-height: 12px;
    min-width: 4px;
    padding: 0 4px;
    text-align: center;
    position: absolute;
    right: -6px;
    top: -4px;
    background-color: ${(props) => props.theme.pink_100};
    border: 2px solid #fff;
    color: ${(props) => props.theme.white};
    letter-spacing: normal;

    ${media.desktop1224} {
        right: -9px;
        top: -7px;
        border-width: 1px;
        font-size: 11px;
        height: 18px;
        line-height: 17px;
        padding: 0 6px;
        min-width: 6px;
    }
`;

export const NavigationMenuText = styled.span`
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;

    ${media.desktop1224} {
        white-space: normal;
        max-width: 150px;
    }
`;
